import classNames from "classnames";
import React from "react";

import getUtilizationLevel from "./get_utilization_level";
import css from "./metric_progress.module.scss";

interface MetricProgressProps {
  value: number;
}

export const MetricProgress = ({ value }: MetricProgressProps) => {
  // TODO: [ENG-129] get low/high values from admin settings
  const level = getUtilizationLevel(value);
  return <progress max="100" value={value} className={classNames(css.progressBar, !!level && css[level])} />;
};
